import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconScienceLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 20.5c-.638 0-1.091-.285-1.36-.854-.269-.57-.204-1.099.195-1.588L9.5 11.173V5H8.308a.726.726 0 0 1-.535-.216.726.726 0 0 1-.215-.534c0-.213.072-.391.215-.534a.726.726 0 0 1 .535-.216h7.384c.213 0 .39.072.535.216a.727.727 0 0 1 .215.534.73.73 0 0 1-.215.535.726.726 0 0 1-.535.215H14.5v6.173l5.665 6.885c.4.49.464 1.019.195 1.588-.269.57-.722.854-1.36.854H5ZM5 19h14l-6-7.3V5h-2v6.7L5 19Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconScienceLine;
